<template>
    <div>
        <div class="tracker-section tracker-section--inline">
            <h2 class="tracker-name heading2 w-100 mb-3">
                Trackers
            </h2>
            
            <input class="form-search-primary" v-model="search" v-debounce:500="getLists" placeholder="Search for a folder or tracker" type="text"/>
            
            <div class="topbar__key">
                <span class="topbar__key__label">Filter by:</span>

                <div class="key__filter" @click="setFilterType('all')">
                    <span class="key__filter__wrapper">
                        <span class="key__filter__tag" :class="{key__filter__connection: filterType != 'all'}">
                            <span>All Trackers</span>
                        </span>
                    </span>
                </div>

                <div class="key__filter"  @click="setFilterType('created-by-me')">
                    <span class="key__filter__wrapper">
                        <span class="key__filter__tag" :class="{key__filter__connection: filterType != 'created-by-me'}">
                            <span>Created By Me</span>
                        </span>
                    </span>
                </div>

                <div v-if="$store.state.user.is_admin" class="key__filter"  @click="setFilterType('related-to-me')">
                    <span class="key__filter__wrapper">
                        <span class="key__filter__tag" :class="{key__filter__connection: filterType != 'related-to-me'}">
                            <span>Related to me</span>
                        </span>
                    </span>
                </div>
            </div>
        </div>

        <div class="main-inner main-inner--scroll">
            <template v-if="foldersLoaded">

                <header class="main-inner__header">
                    <h2 class="heading2">Trackers by Folder</h2>

                    <a class="link" @click="$refs.editFolder.open(0)">+ New Folder</a>

                    <p class="main-inner__header__info" v-if="foldersStatus == 'active'">
                        Showing {{ foldersCount.active }} active folder(s) <a v-if="foldersTotalCount.archived" @click="foldersStatus = 'archived'" class="link-inherit ml-3">Show archived folders</a>
                    </p>

                    <p class="main-inner__header__info" v-if="foldersStatus == 'archived'">
                        Showing {{ foldersCount.archived }} archived folder(s) <a v-if="foldersTotalCount.active" @click="foldersStatus = 'active'" class="link-inherit ml-3">Show active folders</a>
                    </p>

                </header>

                <b-row class="main-inner__content">
                    <b-col md="6" lg="4" v-for="folder in folders[foldersStatus]" :key="folder.id">

                        <div class="card card--bordered">
                            <header class="card__header">
                                <h4 class="heading4 heading4--secondary"><router-link :to="'/trackers/folder/' + folder.id">{{ folder.name }}</router-link></h4>

                                <b-dropdown class="drag-n-drop icons-list dropdown-simple" boundary="viewport">
                                    <b-dropdown-item class="icons-list__edit" @click="$refs.editFolder.open(folder.id)">
                                        <!--<font-awesome-icon :icon="['fa', 'tags']" />-->
                                        Edit Folder
                                    </b-dropdown-item>

                                    <b-dropdown-item class="icons-list__delete" @click="removeFolder(folder.id)">
                                        <font-awesome-icon :icon="['fa', 'trash']" />
                                        Delete
                                    </b-dropdown-item>

                                    <b-dropdown-item class="icons-list__archive" v-if="!folder.archived" @click="archiveFolder(folder.id)">
                                        Archive
                                    </b-dropdown-item>

                                    <b-dropdown-item class="icons-list__archive" v-else @click="unarchiveFolder(folder.id)">
                                        Unarchive
                                    </b-dropdown-item>

                                </b-dropdown>
                            </header>

                            <div class="card__collapse">
                                <header class="card__collapse__header">
                                    <h5 class="heading5 heading5--secondary">{{folder.trackers_count}} tracker(s)</h5>
                                    <b-button v-if="folder.permissions.length || folder.description.length" v-b-toggle="'folder-details-' + folder.id" class="card__collapse__button">Details</b-button>
                                </header>

                                <b-collapse v-if="folder.permissions.length || folder.description.length" :id="'folder-details-' + folder.id">
                                    <p>{{ folder.description }}</p>

                                    <b-dropdown class="dropdown--secondary" variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template #button-content>
                                            <div class="section-users section-users--limited">
                                                <div class="section-users__images">
                                                    <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(folder.permissions)" :key="index" class="section-users__images__item">
                                                        <img :src="avatar" style="width: 30px;" alt=""/>
                                                    </div>
                                                </div>

                                                <p>
                                                    <span class="section-users__data">
                                                        <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(folder.permissions)" :key="index">
                                                            {{item}}
                                                        </a>
                                                    </span>
                                                </p>
                                            </div>
                                        </template>

                                        <b-dropdown-header>
                                            <header class="dropdown__header-inner">
                                                <h4 class="heading4">Users in {{ folder.name }}</h4>

                                                <a v-if="false" href="#" class="link link--lg">Edit</a>
                                            </header>

                                            <ul class="rows-list">
                                                <li  v-for="(permission, index) in folder.permissions" :key="index">
                                                    <div class="rows-list__avatar">
                                                        <Avatar
                                                            :username="permission.name"
                                                            :src="permission.avatar"
                                                            :size="30">
                                                        </Avatar>
                                                    </div>

                                                    <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                                                    <!-- Please add here the logic first -->
                                                    <p class="ml-auto">{{ permission.role.name }}</p>
                                                    <a class="link-info">
                                                        <span class="link-info__content">{{ permission.role.description }}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </b-dropdown-header>
                                    </b-dropdown>
                                </b-collapse>
                            </div>
                        </div>
                    </b-col>

                    <b-col v-if="!foldersTotalCount.active && !foldersTotalCount.archived && !$store.state.user.settings.hide_no_folders" md="6" lg="4">
                        <div class="card card--bordered card--empty">
                            <header class="card__header">
                                <h4 class="heading4">No Folders</h4>
                                <a href="#" class="link-remove" @click="setHideNoFolders"></a>
                            </header>
                            <p>You haven't created any folders yet.</p>
                            <p>Use folders to categorize your trackers so you can easily find and manage them.</p>

                            <footer class="card__footer pt-2">
                                <b-button variant="primary"  @click="$refs.editFolder.open(0)" size="lg" v-b-modal.modal-new-folder>Create A Folder</b-button>
                            </footer>
                        </div>
                    </b-col>
                </b-row>
            </template>

            <template v-if="trackersLoaded">

                <header class="main-inner__header">
                    <h2 class="heading2" v-if="filterType == 'all'">All Trackers</h2>
                    <h2 class="heading2" v-if="filterType == 'created-by-me'">Trackers created by me</h2>
                    <h2 class="heading2" v-if="filterType == 'related-to-me'">Trackers related to me</h2>

                    <a v-if="arrayHelper.inArray($store.state.user.permissions, 'tracker-create')" class="link" @click="$refs.editTracker.open(0)">+ New Tracker</a>

                    <p class="main-inner__header__info" v-if="trackersStatus == 'active'">
                        Showing {{ trackersCount.active }} active tracker(s) <a v-if="trackersTotalCount.archived" @click="trackersStatus = 'archived'" class="link-inherit ml-3">Show archived trackers</a>
                    </p>

                    <p class="main-inner__header__info" v-if="trackersStatus == 'archived'">
                        Showing {{ trackersCount.archived }} archived tracker(s) <a v-if="trackersTotalCount.active" @click="trackersStatus = 'active'" class="link-inherit ml-3">Show active trackers</a>
                    </p>
                </header>
                
                <div class="tabs-primary__inner tabs-primary__inner--noscroll">
                    <table class="main-table" v-if="trackers[trackersStatus].length">
                        <thead>
                        <tr>
                            <th class="main-table__mid">Tracker Name</th>
                            <th>Description</th>
                            <th class="main-table__auto">Startups</th>
                            <th class="main-table__auto">Type</th>
                            <th>Permissions</th>
                            <th>Last Modified</th>
                            <th class="main-table__auto">Actions</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="tracker in trackers[trackersStatus]" :key="tracker.id">
                            <td>
                                
                                <h5 class="heading5 text-break d-flex">
                                    <template v-if="tracker.is_favorite"><span class="icon-favorite"></span></template>
                                    <router-link :to="'/trackers/' + tracker.id">{{ tracker.name }}</router-link>
                                </h5>
                            </td>
                            <td>
                                <div class="main-table__description line-clamp line-clamp4 mb-2" v-html="tracker.description"></div>

                                <div class="shared-ecosystem-label" v-if="tracker.shared_ecosystems_count > 0">
                                    Shared with {{tracker.shared_ecosystems_count}} ecosystem(s)
                                </div>
                            </td>
                            <td>{{ tracker.startups_count }}</td>
                            <td>{{ constants.trackerTypes[tracker.type] }}</td>
                            <td>
                                <b-dropdown class="dropdown--secondary ml-auto" variant="link" toggle-class="text-decoration-none" no-caret>
                                    <template #button-content>
                                        <div class="section-users section-users--limited">
                                            <div class="section-users__images">
                                                <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(tracker.permissions)" :key="index" class="section-users__images__item">
                                                    <img :src="avatar" style="width: 30px;" alt=""/>
                                                </div>
                                            </div>

                                            <p>
                                                <span class="section-users__data">
                                                    <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(tracker.permissions).slice(0, 2)" :key="'1' + index">
                                                        <span v-if="index > 0">, </span>{{ item }}
                                                    </a>
                                                </span>
                                                <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(tracker.permissions).slice(2, 3)" :key="'2' + index">
                                                    {{ item }}
                                                </a>
                                            </p>
                                        </div>
                                    </template>

                                    <b-dropdown-header>
                                        <header class="dropdown__header-inner">
                                            <h4 class="heading4">Users in {{ tracker.name }}</h4>

                                            <a v-if="false" href="#" class="link link--lg">Edit</a>
                                        </header>

                                        <ul class="rows-list">
                                            <li  v-for="(permission, index) in tracker.permissions" :key="index">
                                                <div class="rows-list__avatar">
                                                    <Avatar
                                                        :username="permission.name"
                                                        :src="permission.avatar"
                                                        :size="30">
                                                    </Avatar>
                                                </div>

                                                <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                                                <!-- Please add here the logic first -->
                                                <p class="ml-auto">{{ permission.role.name }}</p>
                                                <a class="link-info">
                                                    <span class="link-info__content">{{ permission.role.description }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </b-dropdown-header>
                                </b-dropdown>
                            </td>
                            <td>
                                {{tracker.last_modified}}
                            </td>
                            <td>
                                <div class="card flex-row">
                                    <b-dropdown v-if="tracker.user_can_edit || tracker.user_can_archive" class="ml-5 drag-n-drop icons-list dropdown-simple dropdown-small" boundary="viewport">
                                        <b-dropdown-item v-if="tracker.user_can_edit" class="icons-list__edit" @click="$refs.editTracker.open(tracker.id)">
                                            Edit Tracker
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="tracker.user_can_edit" class="icons-list__edit" @click="$refs.duplicateTracker.open(tracker.id, tracker.name)">
                                            Duplicate Tracker
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="!tracker.is_favorite" class="icons-list__favorite" @click="setFavorite(tracker.id, 1)">
                                            Mark As Favorite
                                        </b-dropdown-item>

                                        <b-dropdown-item v-else  class="icons-list__favorite" @click="setFavorite(tracker.id, 0)">
                                            Unmark As Favorite
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="tracker.user_can_edit" class="icons-list__delete" @click="removeTracker(tracker.id)">
                                            <font-awesome-icon :icon="['fa', 'trash']" />
                                            Delete Tracker
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="tracker.user_can_archive && tracker.status != 'archive'" class="icons-list__archive" @click="archiveTracker(tracker.id)">
                                            Archive
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="tracker.user_can_archive && tracker.status == 'archive'" class="icons-list__archive" @click="unarchiveTracker(tracker.id)">
                                            Unarchive
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="tracker.user_can_edit" class="icons-list__add" @click="currentTracker = tracker.id; $refs.selectFolder.open()">
                                            Add to Folder
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="!trackersTotalCount.active && !trackersTotalCount.archived" class="card card--bordered card--ordered">
                    <header class="card__header">
                        <h4 class="heading4 heading4--secondary">No Trackers</h4>
                    </header>

                    <div class="card__inner">
                        <div class="card__inner__side">
                            <p>You haven’t created any trackers.</p>
                            <p>Trackers allow you to keep tabs on startups and perform diligence on them. You can also use trackers
                            to create steps  to move startups through as you gather more information to determine their compatibility
                            with your needs.</p>
                        </div>
                        <div v-if="$store.state.user.permissions.indexOf('tracker-create') >= 0" class="card__controls ml-auto">
                            <b-button variant="primary" size="lg" @click="$refs.editTracker.open(0)">Create A Tracker</b-button>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <edit-folder
            ref="editFolder"
            v-on:folderSaved="getLists"
        >

        </edit-folder>

        <edit-tracker
            ref="editTracker"
            :folder-id="0"
            v-on:trackerSaved="getLists"
        >
        </edit-tracker>

        <duplicate-tracker
            ref="duplicateTracker"
            v-on:trackerSaved="getLists"
        >
        </duplicate-tracker>

        <select-folder
            ref="selectFolder"
            v-on:folderSelected="addToFolder"
        >
        </select-folder>
    </div>
</template>

<script>
import trackers from "@/services/trackers.service"
import user from "@/services/user.service"
import editFolder from "@/components/trackers/EditFolder"
import editTracker from "@/components/trackers/EditTracker"
import selectFolder from "@/components/manage/SelectTrackerFolder"
import Avatar from "vue-avatar";
import Vue from "vue";
import DuplicateTracker from "@/components/trackers/Duplicate";

export default {
    data() {
        return {
            folders: {
                active: [],
                archived: [],
            },

            foldersCount: {
                active: 0,
                archived: 0,
            },

            foldersTotalCount:{
                active: 0,
                archived: 0,
            },

            foldersLoaded: 0,

            foldersStatus: null,

            trackers: {
                active: [],
                archived: [],
            },

            trackersCount: {
                active: 0,
                archived: 0,
            },

            trackersTotalCount: {
                active: 0,
                archived: 0,
            },

            trackersLoaded: 0,

            trackersStatus: 'active',
            filterType: "all",

            search: "",
            currentFolder: 0,
            currentTracker: 0,
            updateForAdmin: false,
        }
    },

    components: {
        editFolder,
        editTracker,
        Avatar,
        selectFolder,
        DuplicateTracker,
    },

    mounted() {
        this.$store.watch(state => {
            if (state.user.settings.trackers_filter) {
                this.filterType = state.user.settings.trackers_filter
            }
            else if (state.user.is_admin) {
                this.filterType = "related-to-me"
            }

            this.getLists()

            if (state.needUpdateTrackers) {
                this.getTrackersList()
            }
        })
    },

    watch: {
        filterType() {
            this.getLists()
        }
    },

    methods: {
        getLists() {
            this.getNumbers()
        },

        getNumbers() {
            trackers.getFoldersNumber().then(response => {
                this.foldersTotalCount.active = response.data.active
                this.foldersTotalCount.archived = response.data.archived
                this.getFoldersList()
            })

            trackers.getTrackersNumber().then(response => {
                this.trackersTotalCount.active = response.data.active
                this.trackersTotalCount.archived = response.data.archived
                this.getTrackersList()
            })
        },

        getFoldersList() {
            trackers.getFoldersIndex(this.filterType, this.search).then(response => {
                this.folders = response.data
                this.foldersLoaded = true

                this.foldersCount.active = this.folders['active'].length
                this.foldersCount.archived = this.folders['archived'].length

                if (this.foldersStatus == null) {
                    if (this.foldersTotalCount.active) {
                        this.foldersStatus = 'active'
                    }
                    else if (this.foldersTotalCount.archived) {
                        this.foldersStatus = 'archived'
                    }
                }
            })
        },

        getTrackersList() {
            trackers.getTrackersIndex(this.filterType, this.search).then(response => {
                this.trackers = response.data
                this.trackersLoaded = true

                this.trackersCount.active = this.trackers['active'].length
                this.trackersCount.archived = this.trackers['archived'].length

                if (this.trackersStatus == null) {
                    if (this.trackersTotalCount.active) {
                        this.trackersStatus = 'active'
                    }
                    else if (this.trackersTotalCount.archived) {
                        this.trackersStatus = 'archived'
                    }
                }
            })
        },

        removeTracker(id) {
            if (confirm("Delete tracker?")) {
                trackers.delete(id).then(() => {
                    this.getLists()
                })
            }
        },

        archiveTracker(id) {
            trackers.update(id, {status: 'archive'}).then(() => {
                this.getLists()
            })
        },

        unarchiveTracker(id) {
            trackers.update(id, {status: 'draft'}).then(() => {
                this.getLists()
            })
        },

        removeFolder(id) {
            if (confirm("Delete folder and all its trackers?")) {
                trackers.deleteFolder(id).then(() => {
                    this.getLists()
                })
            }
        },

        archiveFolder(id) {
            if (confirm("Archive folder and all it's trackers?")) {
                trackers.archiveFolder(id).then(() => {
                    this.getLists()
                })
            }
        },

        unarchiveFolder(id) {
            if (confirm("Unarchive folder and all it's trackers?")) {
                trackers.unarchiveFolder(id).then(() => {
                    this.getLists()
                })
            }
        },

        setHideNoFolders() {
            user.updateSettings({'hide_no_folders': 1}).then(response => {
                this.$store.commit('setUser', response.data)
            })
        },

        addToFolder(folder) {
            trackers.addToFolder(folder.id, [this.currentTracker]).then(() => {
                this.currentTracker = 0
                this.getTrackersList()
                this.getFoldersList()

                Vue.notify({
                    group: 'app',
                    type: 'success',
                    duration: 5000,
                    text: "Tracker added to " + folder.name + " folder."
                })
            })
        },

        setFavorite(id, favorite) {
            trackers.setFavorite(id, favorite).then(() => {
                this.getTrackersList()
            })
        },

        setFilterType(filterType) {
            this.filterType = filterType
            user.saveTrackerFilter(this.filterType).then(response => {
                this.$store.commit('setUser', response.data)
            })
        }
    }
}
</script>

<style scoped>

</style>